import { useContext, useMemo } from "react";

import { HeaderContextKeys } from "../../../context/header/header-context";
import CountryContext from "../../../context/country/country-context";

const useHeaderCountryDropdown = ({
    [HeaderContextKeys.countries_dropdown] : items,
}) => {
    const { countryCode } = useContext(CountryContext);

    const activeItemData = useMemo(
        () => items.find(({ value }) => value === countryCode) || {},
        [items, countryCode]
    );

    return [items, countryCode, activeItemData];
};

export default useHeaderCountryDropdown;
